import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/apps/web/app/_layout/footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HideWebviewAppDownloadSection"] */ "/vercel/path0/apps/web/app/[locale]/_app-download/section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Countdown"] */ "/vercel/path0/apps/web/app/[locale]/campaign/[slug]/_sections/countdown.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/[locale]/campaign/[slug]/_sections/event-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Faq"] */ "/vercel/path0/apps/web/app/[locale]/campaign/[slug]/_sections/faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainWithLogging"] */ "/vercel/path0/apps/web/app/[locale]/campaign/[slug]/_sections/main-with-logging.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/[locale]/campaign/[slug]/_sections/prize-entry/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Draws"] */ "/vercel/path0/apps/web/app/[locale]/campaign/[slug]/_sections/spooky-treats-festival/draws/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageOrLottie"] */ "/vercel/path0/apps/web/app/[locale]/campaign/[slug]/_sections/spooky-treats-festival/image-or-lottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TicketOverview"] */ "/vercel/path0/apps/web/app/[locale]/campaign/[slug]/_sections/spooky-treats-festival/ticket-overview/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/ContentfulRichText/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SegmentPage"] */ "/vercel/path0/features/src/misc/segment/segment-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@3.26.4_next@15.5.0_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__re_6f60c95aa2d12de4b02cd8de65b868ef/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@3.26.4_next@15.5.0_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__re_6f60c95aa2d12de4b02cd8de65b868ef/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.5.0_@babel+core@7.28.3_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react_5a64d2da76b76471fdacb3f4f700c114/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["a"] */ "/vercel/path0/packages/react/dist/chunk-6LV6VRHL.js");
;
import(/* webpackMode: "eager", webpackExports: ["a"] */ "/vercel/path0/packages/react/dist/chunk-LJQYNPWJ.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/react/dist/chunk-MG6P47RU.js");
;
import(/* webpackMode: "eager", webpackExports: ["a"] */ "/vercel/path0/packages/react/dist/chunk-MVYYCHRM.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/react/dist/chunk-VA5IYYFE.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/react/dist/design-utils/video.js");
